<template>
    <div class="modal-custom-container">
        <loading v-if="loading" />
        <div v-if="!loading" id="top" class="main-modal">
            <div class="close" @click="$parent.close()">
                <b-icon icon="close"></b-icon>
            </div>
            <div class="section">
                <div>
                    <h5 class="title">{{ $t("Schedual pickup") }}</h5>
                </div>
                <div style="text-align: center">
                    <p
                        style="
                            text-align: center !important;
                            margin: 10px;
                            font-size: 18px;
                            border: 1px solid #ddd;
                            border-radius: 7px;
                            padding: 5px;
                        "
                        class="error"
                        v-if="errorMsg"
                    >
                        {{ $t(errorMsg) }}
                    </p>
                </div>
                <div class="sections">
                    <div class="sec_1">
                        <p class="sec_title font-weight-bold">
                            {{ $t("Pick the best time for you") }}
                        </p>
                        <div class="items">
                            <p
                                @click="activeDay = day"
                                :class="['time', { active: activeDay == day }]"
                                v-for="(day, i) in next3BusinessDays"
                                :key="i"
                            >
                                {{ day | moment("DD-MMM-YYYY") }}
                            </p>
                        </div>
                        <span
                            class="error"
                            v-if="errors.includes('activeDay')"
                            >{{ $t("Required") }}</span
                        >
                    </div>
                    <h6 class="time-title font-weight-bold">
                        {{ $t("Shipment pickup time") }}
                    </h6>
                    <div class="sec_2">
                        <div class="item">
                            <p class="sec_title" style="font-weight: light">
                                {{ $t("From") }}
                            </p>
                            <div class="sec_body">
                                <b-field>
                                    <b-select
                                        v-model="timeFrom"
                                        :placeholder="
                                            $t('Please choose the best time')
                                        "
                                        expanded
                                    >
                                        <option value="09:00:00">
                                            09:00 {{ $t("am") }}
                                        </option>
                                        <option value="10:00:00">
                                            10:00 {{ $t("am") }}
                                        </option>
                                        <option value="11:00:00">
                                            11:00 {{ $t("am") }}
                                        </option>
                                        <option value="12:00:00">
                                            12:00 {{ $t("pm") }}
                                        </option>
                                        <option value="13:00:00">
                                            01:00 {{ $t("pm") }}
                                        </option>
                                        <option value="14:00:00">
                                            02:00 {{ $t("pm") }}
                                        </option>
                                    </b-select>
                                </b-field>
                            </div>
                            <span
                                class="error"
                                v-if="errors.includes('timeFrom')"
                                >{{ $t("Required") }}</span
                            >
                        </div>
                        <div class="item" v-if="timeFrom">
                            <p class="sec_title" style="font-weight: light">
                                {{ $t("To") }}
                            </p>
                            <div class="sec_body">
                                <b-field>
                                    <b-select
                                        v-model="timeTo"
                                        :placeholder="
                                            $t('Please choose the best time')
                                        "
                                        expanded
                                    >
                                        <option
                                            :disabled="
                                                [
                                                    '14:00:00',
                                                    '13:00:00',
                                                    '12:00:00',
                                                ].includes(timeFrom)
                                            "
                                            value="13:00:00"
                                        >
                                            01:00 {{ $t("pm") }}
                                        </option>
                                        <option
                                            :disabled="
                                                [
                                                    '14:00:00',
                                                    '13:00:00',
                                                ].includes(timeFrom)
                                            "
                                            value="14:00:00"
                                        >
                                            02:00 {{ $t("pm") }}
                                        </option>
                                        <option
                                            :disabled="
                                                ['14:00:00'].includes(timeFrom)
                                            "
                                            value="15:00:00"
                                        >
                                            03:00 {{ $t("pm") }}
                                        </option>
                                        <option value="16:00:00">
                                            04:00 {{ $t("pm") }}
                                        </option>
                                        <option value="17:00:00">
                                            05:00 {{ $t("pm") }}
                                        </option>
                                        <option value="18:00:00">
                                            06:00 {{ $t("pm") }}
                                        </option>
                                    </b-select>
                                </b-field>
                            </div>
                            <span
                                class="error"
                                v-if="errors.includes('timeTo')"
                                >{{ $t("Required") }}</span
                            >
                        </div>
                    </div>
                    <div class="sec_2">
                        <div class="item">
                            <p class="sec_title font-weight-bold">
                                {{
                                    $t(
                                        "Where should the courier pick up the shipment?"
                                    )
                                }}
                            </p>
                            <div class="sec_body">
                                <b-field>
                                    <b-select
                                        v-model="package_location"
                                        :placeholder="
                                            $t('Please choose the location')
                                        "
                                        expanded
                                    >
                                        <option value="FRONT">
                                            {{ $t("Front") }}
                                        </option>
                                        <option value="REAR">
                                            {{ $t("Rear") }}
                                        </option>
                                        <option value="SIDE">
                                            {{ $t("Side") }}
                                        </option>
                                    </b-select>
                                </b-field>
                            </div>
                            <span
                                class="error"
                                v-if="errors.includes('package_location')"
                                >{{ $t("Required") }}</span
                            >
                        </div>
                        <div class="item">
                            <p class="sec_title font-weight-bold">
                                {{ $t("Which building part?") }}
                            </p>
                            <div class="sec_body">
                                <b-field>
                                    <b-select
                                        v-model="building_part"
                                        :placeholder="
                                            $t('Please choose the best choice')
                                        "
                                        expanded
                                    >
                                        <option value="APARTMENT">
                                            {{ $t("Apartment") }}
                                        </option>
                                        <option value="BUILDING">
                                            {{ $t("Building") }}
                                        </option>
                                        <option value="DEPARTMENT">
                                            {{ $t("Department") }}
                                        </option>
                                        <option value="FLOOR">
                                            {{ $t("Floor") }}
                                        </option>
                                        <option value="ROOM">
                                            {{ $t("Room") }}
                                        </option>
                                        <option value="SUITE">
                                            {{ $t("Suite") }}
                                        </option>
                                    </b-select>
                                </b-field>
                            </div>
                            <span
                                class="error"
                                v-if="errors.includes('building_part')"
                                >{{ $t("Required") }}</span
                            >
                        </div>
                    </div>

                    <div class="sec_3">
                        <p class="sec_title font-weight-bold">
                            {{ $t("instructions for the courier") }}
                        </p>
                        <div class="sec_body">
                            <b-field>
                                <b-input
                                    v-model="building_description"
                                    type="textarea"
                                    maxlength="150"
                                ></b-input>
                            </b-field>
                            <span
                                class="error"
                                v-if="errors.includes('building_description')"
                                >{{ $t("Required") }}</span
                            >
                        </div>
                    </div>
                </div>
            </div>
            <button
                class="button"
                @click="confirm"
                :disabled="loading"
                style="margin-right: 25px; width: 250px"
            >
                {{ $t("Confirm") }}
            </button>
        </div>
    </div>
</template>

<script>
import moment from "moment";
import momentBusiness from "moment-business-days";
import Loading from "@/components/Loading";

export default {
    props: ["orders"],
    components: {
        Loading,
    },
    data() {
        return {
            next3BusinessDays: [],
            errors: [],
            loading: false,
            activeDay: null,
            timeFrom: null,
            timeTo: null,
            package_location: null,
            building_part: null,
            building_description: null,
            errorMsg: null,
        };
    },
    watch: {
        timeFrom(val) {
            if (!val) return;
            this.timeTo = null;
        },
    },
    methods: {
        confirm() {
            this.loading = true;
            this.errors = [];
            Object.keys(this.$data).map((key) => {
                if (
                    key == "next3BusinessDays" ||
                    key == "errors" ||
                    key == "loading" ||
                    key == "errorMsg"
                )
                    return key;
                if (this.$data[key] == null) {
                    this.errors.push(key);
                }
                return key;
            });
            if (this.errors.length) {
                this.loading = false;
                return document.getElementById("top").scrollIntoView({
                    behavior: "smooth",
                });
            }
            let requestPayload = {
                order_ids: this.$props.orders,
                pickup_date: `${moment(this.activeDay).format("YYYY-MM-DD")} ${
                    this.timeFrom
                }`,
                close_time: this.timeTo,
                package_location: this.package_location,
                building_part: this.building_part,
                building_description: this.building_description,
            };

            this.$store
                .dispatch("PICKUP", requestPayload)
                .then((res) => {
                    this.$store.dispatch("userShipment").then(() => {});
                    this.$parent.close();
                    this.loading = false;
                    window.location.reload();
                })
                .catch((error) => {
                    this.loading = false;
                    this.errorMsg = error.response.data.message[0].message;
                    document.getElementById("top").scrollIntoView({
                        behavior: "smooth",
                    });
                });
        },
    },
    mounted() {
        let currentDay = new Date();
        this.next3BusinessDays.push(
            momentBusiness(
                moment(currentDay).format("DD-MM-YYYY"),
                "DD-MM-YYYY"
            )
        );
        for (let i = 0; i < 4; i++) {
            let currDayFormated = moment(currentDay).format("DD-MM-YYYY");

            let bDay = momentBusiness(
                currDayFormated,
                "DD-MM-YYYY"
            ).nextBusinessDay()._d;
            this.next3BusinessDays.push(bDay);
            currentDay = bDay;
        }
    },
};
</script>

<style lang="scss" scoped>
.font-weight-bold {
    font-weight: bold;
}

.modal-custom-container {
    width: 100%;
    text-align: center;

    .time-title {
        text-align: left;

        &:lang(ar) {
            text-align: right;
        }
    }

    .error {
        color: #ff7977;
    }

    .main-modal {
        position: relative;
        display: inline-block;
        background-color: white;
        width: 945px;
        min-height: 600px;
        border-radius: 15px;

        &:lang(ar) {
            p {
                text-align: right !important;
            }
        }
    }

    .close {
        position: absolute;
        right: 10px;
        top: 15px;
        cursor: pointer;
    }

    .button {
        width: 250px;
        border-radius: 10px;
        margin-top: -50px;
        background: #ff7977;
        color: white;
    }

    .section {
        .title {
            color: #4952ff;
            margin-bottom: 40px;
        }

        .sections {
            text-align: left;

            .sec_1 {
                margin-bottom: 30px;
                text-align: center;

                .sec_title {
                    margin-bottom: 8px;
                }

                .items {
                    display: flex;
                    justify-content: center;
                    flex-wrap: wrap;

                    .time {
                        width: 23%;
                        text-align: center !important;
                        border: 1px solid #777;
                        border-radius: 7px;
                        margin: 7px;
                        padding: 5px;
                        cursor: pointer;

                        &.active {
                            background: #4952ff;
                            color: white;
                        }
                    }
                }
            }

            .sec_time {
                margin-bottom: 40px;
                text-align: center;

                .time_items {
                    display: flex;
                    justify-content: space-between;

                    .time {
                        position: relative !important;
                        text-align: center !important;
                        font-size: 18px;
                        font-weight: bold;
                        width: 48%;
                        background: #f2f2f2;
                        padding: 8px;
                        border-radius: 7px;
                        cursor: pointer;

                        img {
                            position: absolute;
                            top: 3px;
                            right: 20px;
                        }
                    }
                }
            }

            .sec_2 {
                margin-bottom: 30px;
                text-align: center;
                display: flex;
                justify-content: space-between;

                .item {
                    width: 48%;
                }

                .sec_title {
                    margin-bottom: 8px;
                }

                .sec_body {
                    width: 100%;
                }
            }

            .sec_3 {
                text-align: center;
                margin-bottom: 30px;

                .sec_title {
                    margin-bottom: 8px;
                }

                .sec_body {
                    textarea {
                        background: red !important;
                    }
                }
            }
        }
    }
}
</style>
